import React from "react";

/** Blue outline icons for teacher salary receipt detail rows (layout mockup). */
const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const ReceiptCalendarIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <rect x="3.5" y="5" width="17" height="15.5" rx="2" {...stroke} />
    <path d="M3.5 9.5h17M8 3.5v3M16 3.5v3" {...stroke} />
  </svg>
);

export const ReceiptUserIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="8" r="3.25" {...stroke} />
    <path d="M5.5 19.5c1.4-3.2 3.7-4.8 6.5-4.8s5.1 1.6 6.5 4.8" {...stroke} />
  </svg>
);

export const ReceiptDocIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M7 3.5h7.5L19.5 9v11.5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1z" {...stroke} />
    <path d="M14.5 3.5V9H19.5M9 13h6M9 16.5h6" {...stroke} />
  </svg>
);

export const ReceiptAmountIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="8.25" {...stroke} />
    <path d="M12 7.25v9.5M14.5 9.25c-.6-.9-1.5-1.35-2.5-1.35-1.7 0-3 1.05-3 2.55s1.3 2.55 3 2.55 3 1.05 3 2.55-1.3 2.55-3 2.55c-1 0-1.9-.45-2.5-1.35" {...stroke} />
  </svg>
);
